import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="currentColor" fillRule="evenodd">
      <path d="M17 23V8h-2v15z" />
      <path d="M7.341 17.176 16 24.753l8.659-7.577-1.318-1.505L16 22.096 8.659 15.67z" />
      <path d="M17 23V8h-2v15z" />
      <path d="M7.341 17.176 16 24.753l8.659-7.577-1.318-1.505L16 22.096 8.659 15.67z" />
    </g>
  </svg>
);
export default SvgIcArrowDown;
